import { useState } from "react";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch("http://kolibusiness.com/backend/admin-login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    const data = await res.json();
    alert(data.message);

    if (data.success) {
      localStorage.setItem("admin", JSON.stringify(data.admin));
      navigate("/admin");
    }
  };

  return (
    <div style={{ padding: "30px", maxWidth: "400px", margin: "auto" }}>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          name="email"
          type="email"
          placeholder="Email"
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <input
          name="password"
          type="password"
          placeholder="Password"
          onChange={handleChange}
          required
          style={inputStyle}
        />
        <button type="submit" style={btnStyle}>Login</button>
      </form>
    </div>
  );
}

const inputStyle = {
  width: "100%", padding: "10px", margin: "10px 0", borderRadius: "4px", border: "1px solid #ccc"
};

const btnStyle = {
  width: "100%", padding: "10px", background: "#222", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer"
};

export default AdminLogin;
